import React from 'react';

import i18n from '../../i18n';
import { fieldItems } from '../../utils/fields';

// @mui
import { Box, TextField, MenuItem, Typography } from '@mui/material';

export default class DialogItemsField extends React.Component {
    onChange(event) {
        // The empty item of a clearable field means null, not '': an enum is
        // refused as an empty string.
        const value = event.target.value === '' && this.props.field.clearable ? null : event.target.value;
        this.props.onChange(event.target.name, value);
    }

    render() {
        // field, value, cache, onChange

        let translatedName = i18n.t(`columns.${this.props.field.label}`);
        let id = this.props.field.id;
        let name = this.props.field.label;
        let value = this.props.value;
        let onlyRead = !!this.props.field.onlyRead;
        let disabledByTemplate = !!this.props.field.disabledByTemplate;
        const disabled = onlyRead || disabledByTemplate;
        const noTranslate = !!this.props.field.noTranslate;
        // field.enumGroup reads the labels from enums.<group>.<item>, for a page
        // where the shared enums.<item> wording would mislead.
        const enumKey = (item) => (this.props.field.enumGroup
            ? `enums.${this.props.field.enumGroup}.${item}`
            : `enums.${item}`);

        // As in DialogSelectField: a value fixed once the row exists is shown,
        // not offered, on edit — and still sent with the rest of the form.
        if (this.props.field.displayOnEditForReadOnly && this.props.mode === 'edit') {
            return (
                <Box display="flex" gap={1} alignItems="center">
                    <Typography variant="body2" color="textSecondary">
                        {translatedName}:
                    </Typography>
                    {value ? (
                        <Typography variant="body1" color="textPrimary">
                            {noTranslate ? value : i18n.t(enumKey(value))}
                        </Typography>
                    ) : (
                        <Typography variant="body2" color="textSecondary">
                            {i18n.t('common.notSet')}
                        </Typography>
                    )}
                </Box>
            );
        }

        return (
            <TextField
                key={name}
                select
                id={id}
                name={id}
                disabled={disabled}
                label={translatedName}
                value={value || ''}
                fullWidth
                // As the other editors do: the head's helperText under the field.
                helperText={
                    this.props.field.helperText
                        ? i18n.t(`helperTexts.${this.props.field.helperText}`)
                        : undefined
                }
                onChange={(event) => this.onChange(event)}
            >
                {this.props.field.clearable && (
                    <MenuItem value="">
                        <em>{i18n.t('common.notSet')}</em>
                    </MenuItem>
                )}
                {fieldItems(this.props.field, this.props.data).map((item) => (
                    <MenuItem key={item} value={item}>
                        {noTranslate ? item : i18n.t(enumKey(item))}
                    </MenuItem>
                ))}
            </TextField>
        );
    }
}
